import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { URL_EXTENSION } from '@utils/constants/app-constants';
import { BaseError } from '@utils/types/shared/base';
import { ResellerDetailResponse } from '@utils/types/back-office/usage-revenue';

/**
 * Hook to fetch detailed usage data for a specific reseller
 *
 * BACKEND REQUIRED: GET /api/v3/admin/usage/reseller/{reseller_id}
 * Query params: month (YYYY-MM)
 *
 * Returns reseller totals and breakdown by sub-organization
 */
export const useGetResellerDetail = (
  resellerId: number | string | undefined,
  month: string | undefined
) => {
  const fetchResellerDetail = async () => {
    if (!resellerId || !month) {
      throw new Error('Reseller ID and month are required');
    }

    const response = await Axios.get<ResellerDetailResponse>(
      `${URL_EXTENSION}/admin/usage/reseller/${resellerId}?month=${month}`
    );
    return response.data;
  };

  return useQuery<ResellerDetailResponse, AxiosError<BaseError>>(
    ['resellerDetail', resellerId, month],
    fetchResellerDetail,
    {
      enabled: !!resellerId && !!month,
      useErrorBoundary: false
    }
  );
};
